
import React, { useEffect, useMemo, useState } from 'react';
import { prepareHistoricalVolatilityData } from "../utils";
import { Row, Space, Card, Typography, Divider } from 'antd';
import Slide from "../../../components/Slide";
import StockChart from "../../../charts/StockChart";
import NumberInput from "../../../components/Inputs/NumberInput";



const getDateRange = ({items})=>{
    let startDate = items[0].chart[0][0];
    let endDate = items[0].chart[items[0].chart.length-1][0];
    return {startDate, endDate};

}


const HistoricalVolatility = ({ items, itemColors }) => {
    const [windowSize, setWindowSize] = useState(60);
    const [returnsData, setReturnsData] = useState([]);
    const [volatilityData, setVolatilityData] = useState([]);
    const [rollingVolatility, setRollingVolatility] = useState([]);
    const [selectedRange, setSelectedRange] = useState({
        startDate: null,
        endDate: null
    });
    const validRange = useMemo(()=>getDateRange({items}), [items]);

    useEffect(() => {
        if (items.length) {
            const {volatilitySeries, amplifiedSeries, rollingVolatilitySeries} = prepareHistoricalVolatilityData(items, itemColors, windowSize);
            const dateKws = {startDate: selectedRange.startDate, endDate: selectedRange.endDate};
            setReturnsData(amplifiedSeries);
            setVolatilityData(volatilitySeries);
            setRollingVolatility(rollingVolatilitySeries);
        }
    }, [items, itemColors, windowSize, selectedRange]);


    return (
        <>
            <StockChart
                height={'80vh'}
                rangeSelectorRowClassName={'mb-3 round-1 py-3'}
                dataSeries={[
                    {
                        plot: 0,
                        data: volatilityData,
                        disableScrollerChart: true,
                        format: '%',
                        legend: {postfix: '%', precision: 2, format: '%'},
                        yScale: 'percent',
                        yGrid: true,
                        xGridStroke: '1 #ddd'
                    },
                    {
                        plot: 1,
                        data: rollingVolatility,
                        xGrid: false,
                        yGrid: true


                    }
                ]}
                extraMiddle={
                <Space>
                    <NumberInput value={windowSize} onSubmit={setWindowSize} minValue={5} maxValue={90} />
                </Space>
                }
            />
        </>
    );
};

export default HistoricalVolatility;